import { BaseContext } from "src/com/sixdee/crbtportal/utils/basecontext";
import { UIComponentHandler, UIComponentImpl, UIComponentProps, UIComponentState, UIDataModel } from "../../../../toolkit/uicomponent";
import { UIComponentCSSStyle } from "../../../../toolkit/uicomponentcss";
import { UIComponentView } from "../../../../toolkit/uicomponentview";
import { DefaultFlashCardCSSStyleImpl } from "./defaultflashcardcss";
import { DefaultFlashCardViewImpl } from "./defaultflashcardview";

export interface DefaultFlashCardComponentProps extends UIComponentProps
{
    onCreateClick(): void;
}

export interface DefaultFlashCardComponentState extends UIComponentState
{

}

export interface DefaultFlashCardComponentHandler extends UIComponentHandler
{
    onCreateClick(): void;
}

export class DefaultFlashCardComponent extends UIComponentImpl<DefaultFlashCardComponentProps, DefaultFlashCardComponentState, UIDataModel> implements DefaultFlashCardComponentHandler
{
    constructor(props: DefaultFlashCardComponentProps)
    {
        super(props);
    }

    componentDidMount()
    {
        
    }
    UNSAFE_componentWillReceiveProps(nextProps: DefaultFlashCardComponentProps)
    {
        
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new DefaultFlashCardViewImpl(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new DefaultFlashCardCSSStyleImpl(applicationContext);
    }   
    onCreateClick(): void 
    {
        this.props.onCreateClick();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/flashmessage/defaultflashcard/defaultflashcardcomponent.tsx